import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {

    const sections = document.querySelectorAll('.tabbed-component-section');

    sections.forEach(section => {

        const sliderEl = section.querySelector('.tcs-tab-content-slider');
        const sliderContent = sliderEl.querySelectorAll('.tcs-tab-content');
        const tabItems = section.querySelectorAll('.tcs-tab-item');

        let swiperInstance = null;

        // =========================
        // 🔥 LOOP 3-CARD WINDOW LOGIC
        // =========================
        function updateCards(activeIndex) {
            const total = sliderContent.length;

            sliderContent.forEach((content, i) => {
                const pos = (i - activeIndex + total) % total;

                if (pos === 0) {
                    content.classList.add('is-active');
                } else if (pos === 1) {
                    content.classList.add('is-next-1');
                } else if (pos === 2) {
                    content.classList.add('is-next-2');
                } else {
                    content.classList.add('is-hidden');
                }
            });
        }

        function resetCards() {
            sliderContent.forEach((c) => {
                c.classList.remove(
                    'is-active',
                    'is-next-1',
                    'is-next-2',
                    'is-hidden',
                );
            });
        }

        // =========================
        // 🔥 INIT SWIPER (MOBILE ONLY)
        // =========================
        function initSwiper() {

            swiperInstance = new Swiper(sliderEl, {
                spaceBetween: 24,
                slidesPerView: 1,
                centeredSlides: true,
                watchSlidesProgress: true,
                grabCursor: true,
                navigation: {
                    prevEl: section.querySelector('.tcs-button-prev'),
                    nextEl: section.querySelector('.tcs-button-next'),
                },

                pagination: {
                    el: section.querySelector('.tcs-pagination'),
                    clickable: true,
                },
            });
        }

        // =========================
        // 🔥 DESTROY SWIPER
        // =========================
        function destroySwiper() {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        // =========================
        // 🔥 RESPONSIVE HANDLER
        // =========================
        function handleSwiper() {

            const isDesktop = window.innerWidth >= 768;

            if (isDesktop) {
                destroySwiper();
            } else {
                if (!swiperInstance) {
                    initSwiper();
                }
            }
        }

        // =========================
        // 🔥 TAB CLICK (LOOP + SYNC)
        // =========================
        tabItems.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                if (tab.classList.contains('is-active')) {
                    return;
                }

                // =========================
                // 🔵 UPDATE TAB ACTIVE
                // =========================
                tabItems.forEach(t => t.classList.remove('is-active'));
                tab.classList.add('is-active');

                // =========================
                // 🟢 SET NEW ACTIVE
                // =========================
                sliderContent.forEach((content, i) => {
                    content.classList.toggle('is-active', i === index);
                });

                resetCards();
                updateCards(index);
            });
        });

        // =========================
        // 🔥 INIT + RESIZE
        // =========================
        handleSwiper();
        resetCards();
        updateCards(0);
        window.addEventListener('resize', handleSwiper);

    });

});